<template>
  <div class="content has-text-centered">
    <ul
      class="quickMenu"
      :class="{'quickMenu-direction-rtl': Language == 'fa' || Language == 'ar'}"
    >
      <li>
        <router-link :to="'/' + Language + '/profile/personal'">
          <div class="quick-icon">
            <img src="../../assets/img/icons/quick-menu/profile.svg" />
          </div>
          <h4>{{$t('personal_information').tTitle()}}</h4>
        </router-link>
      </li>
      <li>
        <router-link :to="'/' + Language + '/profile/change-password'">
          <div class="quick-icon">
            <img src="../../assets/img/icons/quick-menu/change-password.svg" />
          </div>
          <h4>{{$t('change_password').tTitle()}}</h4>
        </router-link>
      </li>
      <li v-if="IsLive || isIB">
        <router-link :to="'/' + Language + '/profile/upload-documents'">
          <div class="quick-icon">
            <img src="../../assets/img/icons/quick-menu/upload.svg" />
          </div>
          <h4>{{$t('upload_documents').tTitle()}}</h4>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['reason'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      User: 'user/all',
      IsLive: 'user/isLive',
    }),
    isIB() {
      if (!this.User.accountTypes.length) {
        return false
      }
      return this.User.accountTypes.indexOf('ib') !== -1
    },
  },
  mounted() {},
}
</script>

<style lang="scss" >
// @import "../assets/css/variables";
</style>



// WEBPACK FOOTER //
// MyProfileMenu.vue?c560cc4e